import { mergeAttributes, Node } from '@tiptap/core';
import { optimizeStyle } from './utilityFunctions';

export interface TableRowOptions {
  HTMLAttributes: Record<string, never>;
}

export const CustomizedTableRow = Node.create<TableRowOptions>({
  name: 'tableRow',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  content: '(tableCell | tableHeader)*',
  tableRole: 'row',

  parseHTML() {
    return [{ tag: 'tr' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['tr', optimizeStyle(mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)), 0];
  },
});
